import Vue from 'vue'
import router from '../src/router'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    identityConfirmed: false
  },
  mutations: {
    confirmIdentity (state) {
      state.identityConfirmed = true
    }
  },
  actions: {
    redirectToAuthentication () {
      window.localStorage.removeItem('token')

      let query = router.currentRoute.query
      if (router.currentRoute.query.code && router.currentRoute.query.state) {
        query = JSON.parse(router.currentRoute.query.state)
      }

      router.push({
        path: '/login',
        query
      })
    },
    removeToken () {
      window.localStorage.removeItem('token')
    }
  }
})
